import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  rawKey: null, // ArrayBuffer or CryptoKey
  encryptedKey: null, // String
};

const aesKeySlice = createSlice({
  name: "aesKey",
  initialState,
  reducers: {
    setAESKey(state, action) {
      const { rawKey, encryptedKey } = action.payload;
      state.rawKey = rawKey;
      state.encryptedKey = encryptedKey;
    },
  },
});

export const { setAESKey } = aesKeySlice.actions;
export default aesKeySlice.reducer;
